<div class="header-top d-none d-print-flex">
  <div class="header-top-content">
    <img [src]="headerLogo" alt="Logo" />
  </div>
</div>

@let customerNameValue = customerName();
@let portfolioIdValue = portfolioId();
@let buildingsWithPlanValue = buildingsWithPlan();
@let portfolioBuildingsRoadmapValue = portfolioBuildingsRoadmap();
@let lloydsRoadmapValue = lloydsRoadmap();
@let buildingsForAppendicesValue = buildingsForAppendices();
@let yearsValue = years();
@let residentialDecarbonisationPathwayValue = residentialDecarbonisationPathway();
@let nonResidentialDecarbonisationPathwayValue = nonResidentialDecarbonisationPathway();
@let buildingDecarbonisationPathwaysValue = buildingDecarbonisationPathways();
@if (
  portfolioIdValue &&
  buildingsWithPlanValue &&
  portfolioBuildingsRoadmapValue &&
  lloydsRoadmapValue &&
  buildingsForAppendicesValue &&
  yearsValue
) {
  <div class="container">
    <cfp-report-cover-page
      [portfolioId]="portfolioIdValue"
      [logo]="coverLogo"
      [reportTitle]="'lbgPortfolioRoadmapReport.title' | translate"
      [organizationName]="customerNameValue"
      [defaultCoverImage]="'img/report/retll-cover-portfolio.jpg'"
      [coverPageClasses]="'lbg-portfolio-roadmap-report-cover-page'"
      [showPoweredBy]="false"
      [showAsScreenPage]="true"
      [enforcePdfRoute]="false"
    >
      <ng-container cover-footer *ngTemplateOutlet="footerTemplate" />
    </cfp-report-cover-page>
  </div>

  <cfp-printable-content [dataLoaded]="reportDataLoaded()">
    <div body class="container">
      <cfp-report-page
        [portfolioTitle]="customerNameValue"
        [translationKeyPrefix]="translationKeyPrefix"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      >
        <div [innerHtml]="'lbgPortfolioRoadmapReport.page.intro' | translate"></div>
      </cfp-report-page>

      @let portfolioNotesValue = portfolioNotes();
      @if (portfolioNotesValue && portfolioNotesValue.length > 0) {
        <cfp-report-page
          [portfolioTitle]="customerName()"
          [translationKeyPrefix]="translationKeyPrefix"
          [headerLogo]="headerLogo"
          [chromeFooter]="footerTemplate"
        >
          <cfp-notes-list [notes]="portfolioNotesValue" />
        </cfp-report-page>
      }
      <cfp-lbg-report-buildings-pages
        [portfolioId]="portfolioIdValue"
        [customerName]="customerNameValue"
        [lloydsRoadmap]="lloydsRoadmapValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
        (mapReadyForPrint)="mapReadyForPrint.set($event)"
      />
      <cfp-lbg-report-energy-consumption-pages
        [customerName]="customerNameValue"
        [lloydsRoadmap]="lloydsRoadmapValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-report-energy-labels-pages
        [portfolioId]="portfolioIdValue"
        [customerName]="customerNameValue"
        [buildingsWithPlan]="buildingsWithPlanValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [hasBuildingsWithNoPlan]="buildingsWithPlanValue.length < portfolioBuildingsRoadmapValue.buildings.length"
        [years]="yearsValue"
        [translationKeyPrefix]="translationKeyPrefix"
        [showLegend]="false"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-report-investment-pages
        [customerName]="customerNameValue"
        [buildingsWithPlan]="buildingsWithPlanValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [years]="yearsValue"
        [translationKeyPrefix]="translationKeyPrefix"
        [showLegend]="false"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-lbg-report-decarbonisation-pathway-pages
        [customerName]="customerNameValue"
        [residentialPathway]="residentialDecarbonisationPathwayValue"
        [nonResidentialPathway]="nonResidentialDecarbonisationPathwayValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-report-appendices-pages
        [customerName]="customerNameValue"
        [buildings]="buildingsForAppendicesValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [translationKeyPrefix]="translationKeyPrefix"
        [buildingExtraPage]="buildingPathwayPage"
        [buildingExtraPageHeight]="buildingPathwayPageHeight"
        [endsReport]="!showExplanationPage"
        [showEnergyLabelHistory]="false"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />

      @if (showExplanationPage) {
        <cfp-report-page
          [portfolioTitle]="customerNameValue"
          [translationKeyPrefix]="translationKeyPrefix"
          [headerLogo]="headerLogo"
          [chromeFooter]="footerTemplate"
          [lastPage]="true"
          class="d-none d-print-block"
        >
          <div class="report-explanation-page">
            <h2 class="mb-4">{{ 'report.explanationField' | translate }}</h2>
            <div class="report-explanation-field"></div>
          </div>
        </cfp-report-page>
      }
    </div>

    <cfp-report-footer footer [showPoweredBy]="false">
      <ng-container *ngTemplateOutlet="footerTemplate" />
    </cfp-report-footer>
  </cfp-printable-content>
}

<ng-template #buildingPathwayPage let-building let-embedded="embedded" let-lastPage="lastPage">
  @if (buildingDecarbonisationPathwaysValue?.get(building.building.id); as pathway) {
    <cfp-lbg-report-building-decarbonisation-page
      [building]="building"
      [pathway]="pathway"
      [customerName]="customerNameValue"
      [headerLogo]="headerLogo"
      [chromeFooter]="footerTemplate"
      [embedded]="embedded"
      [lastPage]="lastPage"
    />
  }
</ng-template>

<ng-template #footerTemplate>
  <div class="d-flex w-100 justify-content-between">
    <div>{{ 'lbgPortfolioRoadmapReport.footer.left' | translate: { year: currentDate.getFullYear() } }}</div>
    <div [innerHtml]="'lbgPortfolioRoadmapReport.footer.right' | translate"></div>
  </div>
</ng-template>
